// src/components/EditMeeting.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Container,
    Typography,
    Box,
    Paper,
    Grid,
    TextField,
    Button,
    MenuItem
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

const convertDateToInputFormat = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const EditMeeting = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [meeting, setMeeting] = useState(null);
    const [form, setForm] = useState({
        title: '',
        description: '',
        meeting_date: '',
        meeting_time: '',
        client_id: '',
        meeting_type: '',
        status: '',
        notes: ''
    });

    useEffect(() => {
        const fetchMeeting = async () => {
            try {
                const response = await axios.get(`/api/meetings/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setMeeting(response.data);
                setForm({
                    title: response.data.title,
                    description: response.data.description,
                    meeting_date: convertDateToInputFormat(response.data.meeting_date),
                    meeting_time: response.data.meeting_time,
                    client_id: response.data.client_id,
                    meeting_type: response.data.meeting_type,
                    status: response.data.status,
                    notes: response.data.notes
                });
            } catch (error) {
                console.error('Error fetching meeting:', error);
            }
        };
        fetchMeeting();
    }, [id, token]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.put(`/api/meetings/${id}`, form, {
                headers: { Authorization: `Bearer ${token}` }
            });
            navigate('/meetings');
        } catch (error) {
            console.error('Error updating meeting:', error);
        }
    };

    if (!meeting) {
        return <Typography>Ładowanie spotkania...</Typography>;
    }

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h4" gutterBottom>Edycja spotkania</Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Tytuł" name="title" value={form.title} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth label="Opis" name="description" value={form.description} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Data spotkania"
                                    name="meeting_date"
                                    type="date"
                                    value={form.meeting_date}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Godzina"
                                    name="meeting_time"
                                    type="time"
                                    value={form.meeting_time}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField fullWidth label="ID klienta" name="client_id" value={form.client_id} onChange={handleChange} required />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Typ spotkania"
                                    name="meeting_type"
                                    value={form.meeting_type}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="sales">sales</MenuItem>
                                    <MenuItem value="support">support</MenuItem>
                                    <MenuItem value="implementation">implementation</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Status"
                                    name="status"
                                    value={form.status}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="scheduled">scheduled</MenuItem>
                                    <MenuItem value="completed">completed</MenuItem>
                                    <MenuItem value="cancelled">cancelled</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth label="Notatki" name="notes" value={form.notes} onChange={handleChange} multiline rows={3} />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">
                                    Zapisz zmiany
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
};

export default EditMeeting;